import React from 'react';
import StyledButton from './SwatchButton.style';

export default class SwatchButton extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { value, optionName, onClick } = this.props;

    onClick(optionName, value);
  }

  render() {
    const {
      activeBackgroundColor,
      activeColor,
      className,
      inactiveBackgroundColor,
      inactiveColor,
      isDisabled,
      isActive,
      value,
    } = this.props;

    return (
      <StyledButton
        type="button"
        className={className}
        active={isActive}
        disabled={isDisabled}
        activeBackgroundColor={activeBackgroundColor}
        activeColor={activeColor}
        inactiveBackgroundColor={inactiveBackgroundColor}
        inactiveColor={inactiveColor}
        onClick={this.handleClick}
      >
      {value}
      </StyledButton>
    );
  }
}
